import { MutationTree } from 'vuex';
import { ActiveOrderConfiguration, LandingpageState } from './types';

export const mutations: MutationTree<LandingpageState> = {
  activeOrderConfiguration(state, payload: ActiveOrderConfiguration) {
    state.activeOrderConfiguration = payload;
  },
};
